module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "change": _vm.change
    }
  }), _vm._v(" "), (_vm.label) ? [_vm._v("\n    " + _vm._s(_vm.label) + "\n    ")] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1177cce8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckboxInput.vue
// module id = 427
// module chunks = 1